// Requires
const Lang = require('lang');
const GlobalAlerts = require('./GlobalAlerts');
const template = require('lodash/template')
const templateJustifyDontPostCheckingAccount = template(require('../templates/justificativa-nao-lanca-conta-corrente.html'))

// Rotas
const routeExpenseDetails = 'app.despesas.show.conciliacao';

// Selectors
const dataSelectorConfirmItemClose = '[data-confirm-close-itens]';
const dataSelectorbuttonExpenseDetails = '[data-draggable-expense-show-details]';
const dataSelectorPostChekingAccount = '[data-check-confirm-post-checking-account]';
const dataSelectorAdminJustificativa = '[data-admin-justificativa]';
const dalaSelectorSendCloseItem = '[data-checkbox-send-close-item]';
const dataSelectorInvoiceItemDiff = '[data-droppable-invoice-item-diff]';
const dataSelectorDroppableHasExpense = '[data-droppable-has-expense]'
const dataSelectorMessage = '[data-message]';
const classSelectorInvoiceItem = '.invoice-item';
const dataSelectorPostedBalance = '.item-balance-message'
const dataSelectorCheckbox = '.invoice-item__checkbox'


// classes
const classInvoiceItemDifference = 'invoice-item__difference';

function FecharItemsFatura() {
  nifty.body.overlay({
    fixed: true
  });

  settings();
}

/**
 * Configura os listeners e os elementos que
 * devem recebê-los
 */
function settings() {
  const $buttonConfirmClose = $(dataSelectorConfirmItemClose);
  const $buttonShowExpenseDetails = $(dataSelectorbuttonExpenseDetails);
  const $checkboxPostChekingAccount = $(dataSelectorPostChekingAccount);
  const $inputAdminJustificativa = $(dataSelectorAdminJustificativa);
  const $checkBoxCloseItem = $(dalaSelectorSendCloseItem);

  if ($buttonConfirmClose) {
    $buttonConfirmClose.on('click', handlerClickButtonCloseItens)
  }

  if ($buttonShowExpenseDetails.length) {
    $buttonShowExpenseDetails.on('click', handlerClickShowExpenseDetails);
  }

  if ($checkBoxCloseItem.length) {
    $checkBoxCloseItem.each((i, el) => {
      const $el = $(el);
      if (el.checked) {
        $buttonConfirmClose.prop('disabled', false);
      }
      $el.on('change', handlerMarkCheckBoxCloseItem);
    })
  }

  if ($checkboxPostChekingAccount.length) {
    $checkboxPostChekingAccount.each((i, el) => {
      const $el = $(el);
      $el.on('change', handlerUnmarkCheckBoxPostCheckingAccount)
    });
  }

  handlerDiffBetweenInvoiceItemAndExpense();
}

/**
 * Clique do botão de encerrar os itens de fatura
 *
 * Abrindo o modal de confirmação e envio de encerramento
 * dos itens marcados
 *
 * @param {Event} event
 */
function handlerClickButtonCloseItens(event) {
  const buttonConfirm = event.target;
  const form = event.target.closest('form');

  buttonConfirm.disabled = true;
  // Confirmação do usuário para envio da request
  bootbox.confirm({
    title: Lang.get('js/src/functions/FecharItemsFatura.title_modal_confirm'),
    message: Lang.get('js/src/functions/FecharItemsFatura.message_modal_confirm'),
    buttons: {
      confirm: {
        label: Lang.get('js/common/words.yes'),
        className: 'btn-success',
      },
      cancel: {
        label: Lang.get('js/common/words.cancel'),
        className: 'btn-danger'
      }
    },
    callback: function (result) {
      if (!result) {
        buttonConfirm.disabled = false;
        return;
      }

      if (form.dataset.sent === undefined) {
        buttonConfirm.disabled = false;
        form.setAttribute('data-sent', true);
        form.submit();
      }
    }
  });
}

/**
 * Clique do botão de visualização da despesa
 *
 * Enviando uma request ao servidor para obter o conteúdo
 * de informação relacioanda a despesa que o usuário clicou
 * no botão, em seguida um modal será exibido com as
 * informaçoes obtidas
 *
 * @param {Event} event
 */
function handlerClickShowExpenseDetails(event) {
  const idDespesaItem = event.target.closest('.expense-card').dataset.draggableExpenseId;
  const params = {
    despesa: idDespesaItem
  };

  getRequest(params, routeExpenseDetails)
    .done(function (response) {
      const contentModal = document.querySelector('#despesa-detalhes-content');
      contentModal.innerHTML = response;
    })
    .fail(function (error) {
      // Exibindo toast com mensagem de erro padrão
      GlobalAlerts.createAndShow({
        type: 'danger',
        title: Lang.get('js/src/functions/ConciliacoesDroppable.ops'),
        message: Lang.get('js/src/functions/ConciliacoesDroppable.default_error')
      });
    });
}

/**
 * Clique no check box de encerramento do item,
 * ao marca-lo marca também o outro checkbox de contacorrente
 * e verifica se o botão de encerramento está habilitado,
 * se estiver e nenhum checkbox marcado, desabilita o botão,
 * se estiver desabilitado e marcar o checkbox, habilita o botão
 */
function handlerMarkCheckBoxCloseItem(event) {
  const $buttonConfirmClose = $(dataSelectorConfirmItemClose);
  const $checkBoxCloseItem = $(dalaSelectorSendCloseItem);
  const checkBox = event.target;
  const checkBoxCheckingAccount = checkBox.closest('.invoice-item')
    .querySelector(dataSelectorPostChekingAccount);

  // Buscando os elementos de holder da conciliação em questão, sua div onde vai a mensagem
  // a função que monta a mensagem que ira substituir a padrão e o data de se possui uma mensagem
  const $invoiceItemHolder = checkBox.closest(classSelectorInvoiceItem);
  const $invoiceItemMessageDiv = $invoiceItemHolder.querySelector(dataSelectorInvoiceItemDiff);
  const messageData = handleExpenseDifferenceMessage($invoiceItemHolder);

  let disabled = true;

  if (checkBox.checked) {
    if (checkBoxCheckingAccount !== null) {
      checkBoxCheckingAccount.checked = 'checked';
      checkBoxCheckingAccount.closest('.form-checkbox').classList.add('active');
    }

    if ($buttonConfirmClose.attr('disabled')) {
      $buttonConfirmClose.prop('disabled', false);
    }

    // Adicionando a mensagem de saldo a lançar em cc no lugar da que vem por padrão
    if (!messageData.hasMessageStatus) {
      $invoiceItemMessageDiv.querySelector(dataSelectorPostedBalance).innerHTML = messageData.finalMessage;
      $invoiceItemMessageDiv.classList.add(`${classInvoiceItemDifference}--diff`);
    }

    return;
  }

  if (checkBoxCheckingAccount !== null) {
    checkBoxCheckingAccount.checked = null;
    checkBoxCheckingAccount.closest('.form-checkbox').classList.remove('active');
  }

  $checkBoxCloseItem.each((i, el) => {
    if (el.checked) {
      disabled = false;
      return false;
    }
  })

  if (disabled) {
    $buttonConfirmClose.attr('disabled', 'disabled');
  }

  // removendo a mensagem caso o checkbox seja desmarcado
  $invoiceItemMessageDiv.querySelector(dataSelectorPostedBalance).innerHTML = '';
  $invoiceItemMessageDiv.classList.remove(`${classInvoiceItemDifference}--diff`);
}

/**
 * Clique no checkbox de conta corrente, ao desmarca-lo abre o modal para
 * inserir a justificativa do admin para não lançar no conta corrente
 *
 */
function handlerUnmarkCheckBoxPostCheckingAccount(event) {
  const checkBox = event.target;
  const inputAdminJustificativa = document.getElementById(checkBox.value);
  const $paragrafoCommentAdmin = $(inputAdminJustificativa.closest('.invoice-item')).find('[data-comment-admin]');

  const data = {
    justificativa: ''
  };
  if (!checkBox.checked) {
    inputAdminJustificativa.disabled = '';
    bootbox.dialog({
      title: Lang.get('js/src/functions/ConciliacoesDroppable.title_dialog_dont_post_checking_account'),
      message: templateJustifyDontPostCheckingAccount,
      buttons: {
        cancel: {
          label: Lang.get('js/src/functions/ConciliacoesDroppable.cancel'),
          className: 'btn-danger',
          callback: function () {
            checkBox.checked = 'checked';
            checkBox.closest('.form-checkbox').classList.add('active');
            inputAdminJustificativa.disabled = 'disabled';
          }
        },
        confirm: {
          label: Lang.get('js/src/functions/ConciliacoesDroppable.save'),
          className: 'btn-success',
          callback: function () {
            data.justificativa = $(this).find('#justificativa').val();
            // Validando o campo de justificativa, ele é obrigatório
            if (!data.justificativa.length) {
              showError(Lang.get('js/src/functions/ConciliacoesDroppable.error_valid_justify'));
              return false;
            }
            inputAdminJustificativa.value = data.justificativa;
            $paragrafoCommentAdmin.html(
              '<strong>' +
              Lang.get('js/src/functions/ConciliacoesDroppable.justification') +
              ': ' +
              '</strong>' +
              data.justificativa
            )
            $paragrafoCommentAdmin.closest('.invoice-item__comment-admin').removeClass('hidden');
          }
        }
      }
    });
  } else {
    inputAdminJustificativa.value = null;
    inputAdminJustificativa.disabled = 'disabled';
  }
}


/**
 * função que cuida de ajustar as mensagem para os itens que já
 * vierem conciliados e marcados ao carregar a tela
 */
function handlerDiffBetweenInvoiceItemAndExpense() {
  const $invoiceItemHolders = $(classSelectorInvoiceItem);

  // Para cada holder de despesa busca a div de mensagem e seu checkbox
  // monta a mensagem necessária e se estiver marcado adiciona na div de mensagem
  Array.from($invoiceItemHolders).forEach(holder => {
    const $invoiceItemMessageDiv = holder.querySelector(dataSelectorInvoiceItemDiff);
    const checkbox = $($invoiceItemMessageDiv).siblings(dataSelectorCheckbox).find(dalaSelectorSendCloseItem);

    const messageData = handleExpenseDifferenceMessage(holder);

    if (checkbox.is(':checked') &&
      !messageData.hasMessageStatus &&
      messageData.holderData.hasExpense
    ) {
      $invoiceItemMessageDiv.querySelector(dataSelectorPostedBalance).innerHTML = messageData.finalMessage;
      $invoiceItemMessageDiv.classList.add(`${classInvoiceItemDifference}--diff`);
    }
  });
}

/**
 * cuida das alterações necessárias para a div de mensagem do holder
 * que recebe como parametro e retorna a mensagem, se faz parte dos status que deve mostrar
 * e seu data de que possui despesa
 */
function handleExpenseDifferenceMessage(holder) {
  // Buscando a div que vai a mensagem de diferença, o valor da transação,
  // o status do relatório e montando a mensagem que será adicionada
  const $invoiceItemMessageDiv = holder.querySelector(dataSelectorInvoiceItemDiff);
  const amount = $invoiceItemMessageDiv.dataset.invoiceItemAmount;
  const reportStatus = $invoiceItemMessageDiv.dataset.reportStatus;
  const statusMessage = reportStatus == 'AVULSA' ?
    Lang.get('js/src/functions/FecharItemsFatura.expense_detached') :
    Lang.get(
      'js/src/functions/FecharItemsFatura.report_status',
      {
        status: reportStatus,
      }
    );
  const amountMessage = Lang.get(
    'js/src/functions/FecharItemsFatura.amount_will_be_posted_in_checking_account',
    {
      amount: amount,
    }
  );
  const holderData = getDroppableDataAttributes($(holder).find('.expense-gap__droppable')[0]);
  const finalMessage = holderData.hasExpense ?
    `${statusMessage} <br> ${amountMessage}` :
    `${amountMessage}`;
  const showMessageStatuses = ['APROVADO', 'PAGO'];

  return {
    finalMessage: finalMessage,
    hasMessageStatus: showMessageStatuses.includes(reportStatus),
    holderData: holderData
  }
}

/**
 * Enviar request com o método GET para o servidor
 *
 * @param {string} routeName
 * @param {Object} params
 */
function getRequest(params, routeName) {
  return $.ajax({
    url: route(routeName, params),
    method: 'GET',
  });
}

function showError(message = '') {
  GlobalAlerts.createAndShow({
    type: 'danger',
    title: Lang.get('js/src/functions/ConciliacoesDroppable.ops'),
    message: (message === '') ?
      Lang.get('js/src/functions/ConciliacoesDroppable.default_error')
      : message
  });
}

/**
 * Obeter os atributos data, do elemento que é droppable dos cards
 * de despesas
 *
 * @param {Element} element
 * @return Object
 */
function getDroppableDataAttributes(element) {
  return {
    scope: element.dataset.droppableScope,
    hasExpense: (element.dataset.droppableHasExpense === 'true')
  };
}

module.exports = {
  init: FecharItemsFatura,
  url: /^\/admin\/conciliacoes\/encerrar-fatura\/\d/
};
